import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import { connect } from 'react-redux'
import Button from '~components/ui/Button'
import Pagination from '~components/ui/Pagination'
import Message from '~components/ui/Message'
import Sprite from '~components/Sprite'
import classNames from 'classnames'
import { pageView } from '~helpers/ga'
import { debounce } from 'lodash'
import { removeEmptyObjectKeys } from '~helpers/main'

class Invoices extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      search: '',
      messageText: '',
      messageType: '',
      loading: false,
      currentPage: 1,
      totalPages: 1,
      invoices: []
    }

    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.loadInvoicesDebounced = debounce(this.loadInvoices, 500)
  }

  componentDidMount () {
    pageView()

    this.loadInvoices()
  }

  setMessage (type, message) {
    this.setState({
      messageType: type,
      messageText: message
    })

    setTimeout(() => {
      this.setState({
        messageType: ''
      })
    }, 5000)
  }

  loadInvoices (page = 1) {
    if (this.state.loading) return
    const search = this.state.search ?? ''
    const params = removeEmptyObjectKeys({ page, search })

    this.setState({ loading: true })

    axios.get('/api/account/invoices', { params })
      .then(response => {
        this.setState({
          invoices: response.data.data,
          currentPage: response.data.current_page,
          totalPages: response.data.last_page
        })
      })
      .finally(() => {
        this.setState({
          loading: false
        })
      })
  }

  resendInvoice (id) {
    if (this.state.loading) {
      return
    }

    this.setState({
      loading: true
    })

    axios.put(`/api/account/invoices/${id}/resend`)
      .then(() => {
        this.setMessage('success', `Invoice ${id} re-sent.`)
      })
      .catch(() => {
        this.setMessage('error', 'Invoice resend failed.')
      })
      .finally(() => {
        this.setState({
          loading: false
        })
      })
  }

  handlePageChange (i) {
    if (this.state.totalPages >= i && i > 0 && i !== this.state.currentPage) {
      this.loadInvoices(i)
    }
  }

  handleSearchChange (event) {
    this.setState({
      search: event.target.value
    }, () => this.loadInvoicesDebounced(1))
  }

  render () {
    return (
      <>
        {this.state.messageText &&
          <Message
            messageType={this.state.messageType}
            messageText={this.state.messageText}
          />}

        <section className="mt-10 mb-10 xl:mt-0 xl:mb-20">
          <h3 className="text-left text-md border-b border-coral pb-4">
            Invoices
          </h3>

          <div className="lg:float-left lg:inline-block mt-6 mb-8">
            <div className="relative flex-1 z-40 h-12">
              <input
                type="text"
                name="invoicesSearch"
                onChange={this.handleSearchChange}
                className="relative block text-charcoal focus:bg-white focus:border-coral duration-200 ease-in-out h-full w-full transition-colors rounded-3xl p-4 pr-12 bg-lightGrey border border-pink color-charcoal placeholder-charcoal outline-none z-10"
                placeholder="Search"
              />

              <button className="w-10 h-full flex flex-col cursor-pointer absolute top-0 bottom-0 right-1 z-20" type="submit" value="submit" aria-label="Submit">
                <span className="block m-auto w-6 h-6" aria-hidden="true">
                  <Sprite name="search" />
                </span>
              </button>
            </div>
          </div>

          <div className="overflow-x-auto w-full">
            <table className="w-full border border-pink">
              <thead className="border-b border-pink">
                <tr>
                  <th className="p-4 sm:p-6 text-left font-light">
                    {'Invoice ID\'s'}
                  </th>
                  <th className="p-4 sm:p-6 text-left font-light">
                    Date
                  </th>
                  <th className="p-4 sm:p-6 text-left font-light">
                    Amount
                  </th>
                  <th className="p-4 sm:p-6 text-left font-light">
                    Status
                  </th>
                  <th className="p-4"></th>
                </tr>
              </thead>
              <tbody>
                {this.state.invoices.map((invoice, index) => {
                  const classes = []

                  if (index % 2 === 0) {
                    classes.push('bg-pink')
                  }

                  return (
                    <tr key={invoice.invn65}>
                      <td className={classNames('p-4 sm:px-6 pr-0', classes)}>
                        {invoice.invn65}
                      </td>
                      <td className={classNames('p-4 sm:px-6 pr-0', classes)}>
                        {invoice.dtin65.split(' ')[0]}
                      </td>
                      <td className={classNames('p-4 sm:px-6 pr-0', classes)}>
                        {invoice.invg65}
                      </td>
                      <td className={classNames('p-4 sm:px-6 pr-0', classes)}>
                        {invoice.outstanding > 0 ? 'Outstanding' : 'Paid'}
                      </td>
                      <td className={classNames('p-4 sm:px-6 text-right', classes)}>
                        <Button type="button" className="w-auto" disabled={this.state.loading} onClick={() => this.resendInvoice(invoice.invn65)}>
                          Resend invoice
                        </Button>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>

          <Pagination
            totalPages={this.state.totalPages}
            onClick={this.handlePageChange.bind(this)}
            currentPage={this.state.currentPage}
            className="mb-10 xl:my-20"
          />
        </section>
      </>
    )
  }
}

Invoices.propTypes = {
  account: PropTypes.object,
  setAccount: PropTypes.func
}

export default connect()(Invoices)
